module.exports = __webpack_public_path__ + "media/images/courseware_schoology_courses_icon-be54711d406161da79108416b40001ba.png";